/* global google */

function initAutocomplete() {
  // Get the input element for the clinic search
  const input = document.getElementById('clinics_clinic-search');
  if (!input) {
    console.error('Input element not found');
    return;
  }

  // Initialize the Google Places Autocomplete with restrictions to Canada
  const autocomplete = new google.maps.places.Autocomplete(input, {
    componentRestrictions: { country: 'ca' },
  });

  // Check if the findstr object and hooks are available
  const findstr = window.findstr || {};

  // Add a filter to clear the search query after place selection
  if (findstr.hooks?.addFilter) {
    findstr.hooks.addFilter(
      'findstrBuildSearchQuery',
      'findstr-search',
      (query) => {
        query.q = ''; // Clear the search query after place selection
        return query;
      },
      999
    );
  }

  // Event listener for when a place is selected from the autocomplete suggestions
  autocomplete.addListener('place_changed', () => {
    const place = autocomplete.getPlace();
    if (!place.geometry) {
      console.log(`No details available for input: '${place.name}'`);
      return;
    }

    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();

    // Check if lat and lng are valid
    if (lat && lng) {
      // Add a filter to sort the search results by distance from the selected place
      if (findstr.hooks?.addFilter) {
        findstr.hooks.addFilter(
          'findstrBuildSearchQuery',
          'findstr-search',
          (query) => {
            query.sort = { [`_geoPoint(${lat},${lng})`]: 'asc' };
            query.q = ''; // Clear the search query after place selection
            return query;
          }
        );

        // Trigger the search with the updated query
        findstr.search?.();
      } else {
        console.error('findstr or findstr.hooks.addFilter is not defined');
      }
    } else {
      console.error('Latitude and Longitude are not defined');
    }

    // Dispatch an input event to trigger any additional input listeners
    input.dispatchEvent(
      new Event('input', { bubbles: true, cancelable: true })
    );
  });

  // Add a debounced input event listener to trigger the search on user input
  input.addEventListener(
    'input',
    debounce(() => findstr.search?.(), 300)
  );
}

// Function to debounce the execution of another function
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

// Expose the initAutocomplete function to the global scope
window.initAutocomplete = initAutocomplete;
